import { render, staticRenderFns } from "./SuccessAcademySections.vue?vue&type=template&id=15982236&scoped=true&"
import script from "./SuccessAcademySections.vue?vue&type=script&lang=js&"
export * from "./SuccessAcademySections.vue?vue&type=script&lang=js&"
import style0 from "./SuccessAcademySections.vue?vue&type=style&index=0&id=15982236&prod&lang=scss&scoped=true&"
import style1 from "./SuccessAcademySections.vue?vue&type=style&index=1&id=15982236&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15982236",
  null
  
)

export default component.exports